import {EkAlanTuru} from "@/enum/EkAlanTuru";

export class TakipEkAlanTuruEntity {
    id!: number;
    kod!: string;
    isim!: string;
    tur!: EkAlanTuru;
}
